import { CheckCircle, XCircle } from "lucide-react";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

const OAuthCallback = () => {
  const [message, setMessage] = useState("Processing authorization...");
  const [error, setError] = useState(null);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    console.log(
      "OAuthCallback: Component mounted, location:",
      window.location.href
    );
    const handleCallback = async () => {
      const success = searchParams.get("success");
      const error = searchParams.get("error");
      const brokerAccountId = searchParams.get("brokerAccountId");

      if (error) {
        setError(error);
        setMessage("Authorization failed");
        // Send message to parent window if in popup
        if (window.opener) {
          window.opener.postMessage(
            {
              type: "SCHWAB_OAUTH_ERROR",
              error: error,
            },
            window.location.origin
          );
        }
        return;
      }

      if (success && brokerAccountId) {
        console.log(
          "OAuthCallback: Success detected, brokerAccountId:",
          brokerAccountId
        );
        setMessage("Authorization successful! You can close this window.");

        // Send success message to parent window if in popup
        if (window.opener) {
          console.log(
            "OAuthCallback: Sending success message to parent window"
          );
          
          const brokerName = searchParams.get("brokerName") || "schwab";
          
          window.opener.postMessage(
            {
              type: "BROKER_OAUTH_SUCCESS",
              brokerAccountId: brokerAccountId,
              brokerName: brokerName,
            },
            window.location.origin
          );

          // Legacy support for App.js/Brokers.js until updated
          if (brokerName === "schwab") {
             window.opener.postMessage(
                {
                  type: "SCHWAB_OAUTH_SUCCESS",
                  brokerAccountId: brokerAccountId,
                },
                window.location.origin
              );
          }

          // Close popup after showing success message
          setTimeout(() => {
            console.log("OAuthCallback: Closing popup window");
            window.close();
          }, 2000);
        } else {
          console.log("OAuthCallback: No opener window found");
        }
      }
    };

    handleCallback();
  }, [searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-900 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-slate-900 via-slate-900 to-black relative overflow-hidden">
        {/* Background Decor */}
        <div className="absolute top-0 -left-4 w-72 h-72 bg-purple-500 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob"></div>
        <div className="absolute top-0 -right-4 w-72 h-72 bg-emerald-500 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob animation-delay-2000"></div>
        <div className="absolute -bottom-8 left-20 w-72 h-72 bg-pink-500 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob animation-delay-4000"></div>

      <div className="relative w-full max-w-md p-8 mx-4">
        <div className="bg-slate-800/50 backdrop-blur-xl border border-slate-700/50 rounded-2xl shadow-2xl p-8 text-center">
            
          <div className="flex justify-center mb-6">
            <div className={`p-4 rounded-full ${error ? 'bg-red-500/10' : 'bg-emerald-500/10'}`}>
                {error ? (
                    <XCircle size={48} className="text-red-500" />
                ) : (
                    <CheckCircle size={48} className="text-emerald-500" />
                )}
            </div>
          </div>
          
          <h1 className={`text-2xl font-bold mb-4 ${error ? 'text-red-400' : 'text-emerald-400'}`}>
            {error ? "Authorization Failed" : "Authorization Complete"}
          </h1>
          
          <p className="text-slate-400 mb-6">{message}</p>
          
          {error && (
            <button
              onClick={() => window.close()}
              className="bg-red-500 hover:bg-red-600 text-white font-bold py-2 px-6 rounded-lg transition-colors shadow-lg shadow-red-500/20"
            >
              Close Window
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default OAuthCallback;
